import React, { useEffect } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import Campaign from './Campaign';
import AtHome from './AtHome';
import Webinar from './Webinar';
import KnowMore from './KnowMore';
import { campaign as campaignActions } from '../../redux/actions';
import apis from '../../app/apis';
import cts from '../../app/cts';

const Container = styled.div`
  box-sizing: border-box;
  float: right;
  width: calc(50% - 5px);

  /* 
##Device = Desktops
##Screen = 1281px to higher resolution desktops
*/


@media (min-width: 1281px) {
  float: right;
  width: calc(50% - 5px);
}

/* 
  ##Device = Laptops, Desktops
  ##Screen = B/w 1025px to 1280px
*/

@media (min-width: 1025px) and (max-width: 1280px) {
  float: right;
  width: calc(50% - 5px);
}

/* 
  ##Device = Tablets, Ipads (portrait)
  ##Screen = B/w 768px to 1024px
*/

@media (min-width: 768px) and (max-width: 1024px) {
  float: right;
  width: calc(50% - 5px);
}

/* 
  ##Device = Tablets, Ipads (landscape)
  ##Screen = B/w 768px to 1024px
*/

@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  float: right;
  width: calc(50% - 5px);
}

/* 
  ##Device = Low Resolution Tablets, Mobiles (Landscape)
  ##Screen = B/w 481px to 767px
*/

@media (min-width: 481px) and (max-width: 767px) {
  width: 100%;
}

/* 
  ##Device = Most of the Smartphones Mobiles (Portrait)
  ##Screen = B/w 320px to 479px
*/

@media (min-width: 320px) and (max-width: 480px) {
  width: 100%;
}

/* 
  ##Device = smallest smart phones
  ##Screen = max 319px
*/

@media (max-width: 319px) {
  width: 100%;
}
`;


const Boxes = ({
  hasActiveCampaign,
  projectId,
  districtId,
  setCampaignInfo,
  setHasActiveCampaign
}) => {
  useEffect(() => {
    const getActiveCampaign = async () => {
      try {
        const { data } = await cts('get', apis.activeCampaignUrl({ projectId, districtId }));
        if (data.message === 'No active campaign available') {
          throw new Error('Error! No active campaign');
        }
        setHasActiveCampaign(true);
        setCampaignInfo(data);
      } catch (e) {
        setCampaignInfo({});
        setHasActiveCampaign(false);
      }
    };
    getActiveCampaign();
  // TODO: Check how we can remove functions from dependencies
  }, [districtId, setHasActiveCampaign, setCampaignInfo, projectId]);

  return (
    <Container>
      {
        hasActiveCampaign && <Campaign />
      }
      <KnowMore />
      <AtHome />
      <Webinar />
    </Container>
  );
};

const mapStateToProps = (state) => ({
  hasActiveCampaign: state.campaign.hasActiveCampaign,
  districtId: state.app.districtId,
  projectId: state.app.projectId
});

const mapDispatchToProps = (dispatch) => ({
  setCampaignInfo: (info) => dispatch(campaignActions.setCampaignInfo(info)),
  setHasActiveCampaign: (active) => dispatch(campaignActions.setHasActiveCampaign(active))
});

export default connect(mapStateToProps, mapDispatchToProps)(Boxes);
